export const agreement1 = `1. 포인트 정의: 포인트는 공식 웹상점에서 결제 시 지급되는 증정 혜택으로, 공식 웹상점 내 상품 구매 시 사용할 수 있습니다.
2. 공식 웹상점에서 상품 결제 시, 결제 금액의 15%가 포인트로 적립됩니다.
예시: 공식 웹상점에서 75,000원의 패키지 구매 후, 11,250포인트를 획득할 수 있습니다.
3. 포인트는 별도의 사용 기한이 없으며 영구적으로 유효합니다.
4. 포인트와 현금의 가치 비율은 1:1입니다.
예시: 30,000포인트로 30,000원 상당의 패키지 구매가 가능합니다.
`
export const title1='이용 규칙:'
export const agreement2 = `1. 로그인 후 반드시 계정 및 선택한 캐릭터 정보를 정확히 확인한 뒤 구매를 진행해 주시기 바랍니다.
2. 공식 웹상점에서는 로그인한 캐릭터가 게임 내에서 구매 가능한 상품만 노출됩니다. 상품의 구매 제한 횟수 및 조건은 게임 내 상점과 동일하게 적용됩니다.
게임 내에서 해당 상품이 해제되지 않았거나, 이미 구매 횟수 제한에 도달한 상품은 본 페이지에 노출되지 않습니다. '첫 결제 2배 캐시백' 등 구체적인 내용은 게임 내 실제 표시를 기준으로 합니다.
3. 공식 웹상점에서 구매하신 상품은 결제 시 선택한 캐릭터로 지급되며 게임 내에서 확인하시기 바랍니다. 상품 지급 상태는 게임 내 실제 표시를 기준으로 합니다. 결제 완료 후 30분 이내에 상품을 받지 못하셨거나 지급된 상품에 문의가 있으실 경우, 고객센터로 문의해 주시기 바랍니다.
4. 구매 시 선택한 캐릭터가 게임에 접속 중인 경우, 상품 지급 즉시 게임 내 팝업으로 알림이 제공됩니다. 캐릭터가 로그아웃 상태인 경우에는 상품이 해당 캐릭터의 게임 내 우편함으로 발송되니 게임 접속 후 우편함을 확인해 주시기 바랍니다.
5. 포인트와 현금은 독립된 결제 수단으로 복합 결제가 불가능합니다. 상품 결제 시 한 가지 결제 수단만 선택할 수 있으며, 전액 포인트 또는 전액 현금으로만 결제 가능합니다. 
6. 공식 웹상점에서 결제(현금, 포인트) 시, 게임 내 충전 포인트가 정상적으로 반영됩니다.
`
export const title2='주의사항：'
export const agreement3 = `1. 주문 상품을 사용한 경우, 어떠한 조건에서도 환불이 불가능합니다. ‘사용’이란 주문을 통해 획득한 어떤 아이템이라도 수령·소모·교환하는 등의 행위를 포함합니다.
2. 포인트는 공식 웹상점 결제로 발생한 주문에 한해 비율대로 적립되는 부수적인 증정 혜택이며, 환불·교환·양도·이전·선물·현금화가 불가능합니다. 또한, 이미 사용된 포인트는 소모된 것으로 간주되어 소멸하며 재지급 또는 사용 취소가 불가합니다.
3. 공식 웹상점 이외의 타 경로를 통해 발생한 주문은 포인트 적립 대상에 포함되지 않으며, 공식 웹상점 주문과 합산하여 계산할 수 없습니다.
`
export const title3='환불 안내:'